// schema/nodes/accordeon.ts
import { HTMLBaseAccordeon } from "../../db/HTMLBaseAccordeon.js";
var ACCORDEON_CONTAINER_SCHEMA = () => ({
  draggable: true,
  atom: true,
  isolating: true,
  group: "block",
  selectable: true,
  content: "accordeon+",
  attrs: {
    data: { default: JSON.stringify(new HTMLBaseAccordeon({}).toObject()) }
  },
  parseDOM: [
    {
      tag: "node-accordeon-container",
      getAttrs(dom) {
        return {
          data: dom.getAttribute("data")
        };
      }
    }
  ],
  toDOM(node) {
    return ["node-accordeon-container", { data: node.attrs.data }, 0];
  }
});
var ACCORDEON_TITLE_SCHEMA = () => ({
  draggable: true,
  atom: true,
  selectable: false,
  isolating: true,
  content: "block+",
  group: "accordeon_title",
  parseDOM: [
    {
      tag: 'div[slot="accordeon-title"]'
    }
  ],
  toDOM() {
    return ["div", { slot: "accordeon-title" }, 0];
  }
});
var ACCORDEON_CONTENT_SCHEMA = () => ({
  draggable: true,
  atom: true,
  selectable: false,
  isolating: true,
  content: "block+",
  group: "accordeon_content",
  parseDOM: [
    {
      tag: 'div[slot="accordeon-content"]'
    }
  ],
  toDOM() {
    return ["div", { slot: "accordeon-content" }, 0];
  }
});
var ACCORDEON_SCHEMA = () => ({
  draggable: true,
  selectable: false,
  atom: true,
  isolating: true,
  content: "accordeon_title accordeon_content",
  group: "accordeon",
  parseDOM: [
    {
      tag: "node-accordeon"
    }
  ],
  toDOM() {
    return ["node-accordeon", {}, 0];
  }
});
var ACCORDEON_CONTAINER_KEY = "accordeon-container";
var ACCORDEON_TITLE_KEY = "accordeon-title";
var ACCORDEON_CONTENT_KEY = "accordeon-content";
var ACCORDEON_KEY = "accordeon";
var ACCORDEON = {
  [ACCORDEON_CONTAINER_KEY]: ACCORDEON_CONTAINER_SCHEMA(),
  [ACCORDEON_TITLE_KEY]: ACCORDEON_TITLE_SCHEMA(),
  [ACCORDEON_CONTENT_KEY]: ACCORDEON_CONTENT_SCHEMA(),
  [ACCORDEON_KEY]: ACCORDEON_SCHEMA()
};
export {
  ACCORDEON,
  ACCORDEON_CONTAINER_KEY,
  ACCORDEON_CONTAINER_SCHEMA,
  ACCORDEON_CONTENT_KEY,
  ACCORDEON_CONTENT_SCHEMA,
  ACCORDEON_KEY,
  ACCORDEON_SCHEMA,
  ACCORDEON_TITLE_KEY,
  ACCORDEON_TITLE_SCHEMA
};
